import * as React from "react";
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'
import {ReactUtilities} from "shared/utilities/react/ReactUtilities";




export class ColorButton extends React.Component<ColorButtonProps, ColorButtonState> {
    static defaultProps: Partial<ColorButtonProps> = {
        Color:''
    };
    public lastColor:string;
    constructor(props: ColorButtonProps) {
        super(props);
        this.state = {
            displayColorPicker:false
        };
    }

    public render() {
        let colorToUse=this.props.Color!=''?this.props.Color:`#000`;
        const styles = reactCSS({
            'default': {
                color: {
                    width: '18px',
                    height: '14px',
                    borderRadius: '2px',
                    background: colorToUse
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'fixed',
                    zIndex: '2'
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });


        return (
            <div style={{display:'inline-block'}}>
                <div style={ styles.swatch } onMouseDown={ (e)=>{e.preventDefault(); this.setState({displayColorPicker:!this.state.displayColorPicker})} }>
                    <div style={ styles.color } />
                </div>
                { this.state.displayColorPicker ?
                    <div style={ styles.popover as any } className={'rnColorPopOver'}>
                        <div style={ styles.cover as any } onClick={ e=>{this.setState({ displayColorPicker: false })} }/>
                        <SketchPicker color={ colorToUse} onChange={ e=>{this.lastColor=e.hex;}}  />
                        <div style={{backgroundColor:'white',textAlign:'center',marginBottom:2,position:'relative',zIndex:10}}>
                            <button className={'rnbtn rnbtn-primary'} onMouseDown={e=>{e.preventDefault();e.stopPropagation();this.ColorSelected()}} >Select</button>
                        </div>
                    </div> : null }

            </div>
        )

    }

    private ColorSelected() {

        if(this.lastColor!='') {
            ReactUtilities.ExecuteMethodPropIfDefined(this.props.ColorChanged,this.lastColor);
            this.lastColor='';
        }
        this.setState({displayColorPicker:false});
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface ColorButtonProps {
    ColorChanged:(color:string)=>void;
    Color:string;
}

interface ColorButtonState {
    displayColorPicker:boolean;
}

//#endregion "My Region"